import { useEffect, useState } from "react";
import { loadCMS, getData, subscribe } from "./storage";

/**
 * Reactive CMS hook.
 * - Loads data on first mount.
 * - Re-fetches when the tab regains focus (covers multi-device edits).
 * - Listens to in-app mutation events (admin → public propagation).
 */
export function useCMS() {
  const [data, setData] = useState(() => getData());

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const fresh = await loadCMS();
        if (!cancelled) setData(fresh);
      } catch {
        /* keep previous data */
      }
    };

    if (!data) load();
    const off = subscribe((d) => { if (!cancelled) setData(d); });
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);

    return () => {
      cancelled = true;
      off();
      window.removeEventListener("focus", onFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
}
